<template>
    <div class="card">
            <div class="card-body">
              <!--
                <h5 class="card-title">{{location.fullDisplayName}} ({{ location.microinverters }} Panels)
                    <button class="btn pull-right" @click="refreshLocation()"><font-awesome-icon :icon="['fas', 'arrows-rotate']"/></button>
                </h5>
              -->

                <div v-if="location.loading">
                    Loading ...
                </div>
                <div v-else>
                    <div v-if="location.error">
                        <span style="color: red;">
                            Error: {{ location.error }}
                        </span>
                    </div>
                    <div v-if="location.chartData">
                      <v-container class="chart-container">
                        <Bar
                            :options="myChartOptions"
                            :data="location.chartData" />
                      </v-container>
                    </div>
                </div>
                
            </div>
          </div>
  </template>
  
  <script>
  //import pb from '../api';
  //import { useToast } from 'vue-toastification';
  //import { store } from '../store';
  //import { confirm } from '@zapadale/vue3-confirm-dialog'

  import { Bar } from 'vue-chartjs'
  import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, SubTitle } from 'chart.js'
  ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, SubTitle)
  
  export default {
    name: 'SolarLocation',
    components: {
        Bar
    },
    props: ['location', 'chartOptions'],
    data() {
      return {
        myChartOptions: null
      };
    },
    async mounted() {
      let myChartOptions = JSON.parse(JSON.stringify(this.chartOptions));
      myChartOptions.plugins = {
                title: {
                    display: true,
                    text: `${this.location.fullDisplayName}`,
                    font: {
                        size: 20
                    }
                },
                subtitle: {
                  display: true,
                  text: `${this.location.microinverters} Panels`,
                  font: {
                    size: 16
                  }
                }
            };
      this.myChartOptions = myChartOptions;
    },
    methods: {
      refreshLocation() {
        this.$emit('refreshLocation', this.location);
      }
    }
  };
  </script>
  
  <style scoped>  
  .card {
    /*
    cursor: pointer;
    */
  }


  .chart-container {
  flex-grow: 1;
  /*min-height: 0;*/
  min-height: 325px;

  > div {
    position: relative;
    height: 100%;
  }
}
  </style>